<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <InformationAlert 
      title="Information"
      :description="alertConfig.description"
      :items="alertConfig.infoItems"
    />
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterType"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :refresh-table="getData"
    >     
    <template v-slot:top>
      </template>
      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="moveOutletToM(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-swap-horizontal</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title
                    >Change Outlet to Merchant</v-list-item-title
                  >
                </v-list-item>
                <v-list-item link @click="moveOutletToOM(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-swap-horizontal</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title
                    >Move Outlet to Other Merchant</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
      </template>
      </TableView>

    <outlet-to-merchant
      :dialogOtoM="dialogOtoM"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      v-on:closeCancelParent="close"
    />

    <outlet-to-other-merchant
      :dialogOtoOM="dialogOtoOM"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      v-on:closeCancelParent="close"
      v-on:fetchDataParent="getData"
    />
  </v-card>
</template>

<script>
import outletManagementMixin from '../../components/merchant-tools/outlet-management/outletManagementMixin';

export default {
  mixins:[outletManagementMixin],
  components: {
    outletToMerchant: () =>
      import('../../components/form/OutletToMerchant.vue'),
    outletToOtherMerchant: () =>
      import('../../components/form/OutletToOtherMerchant.vue'),
    TableSearchFilter: () => import("@components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TableView: () => import("@components/@drontVue/components/Table/TableView.vue"),
    InformationAlert: () => import("@components/@drontVue/components/InformationAlert/index.vue"),
  },
};
</script>